var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAsset26(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 270.04 181.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke: #dc2c2c;\n      }\n\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 14.04px;\n      }\n\n      .cls-2 {\n        stroke: #10519e;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_14",
    "data-name": "Layer 14"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M263.02,19.84v132.41H7.02V19.84c0-7.08,5.74-12.82,12.83-12.82h230.33c7.09,0,12.83,5.74,12.83,12.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M263.02,152.25v9.9c0,7.08-5.74,12.82-12.83,12.82H19.85c-7.09,0-12.83-5.74-12.83-12.82v-9.9h256Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 44.69,
    cy: 108.1,
    r: 15.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 110.03,
    cy: 82.82,
    r: 15.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 158.42,
    cy: 108.1,
    r: 15.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 225.35,
    cy: 67.29,
    r: 15.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 62.19,
    y1: 102.41,
    x2: 94.5,
    y2: 90.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 125.56,
    y1: 87.4,
    x2: 142.89,
    y2: 98.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 176.03,
    y1: 101.75,
    x2: 209.82,
    y2: 77.04
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset26);
export default __webpack_public_path__ + "static/media/Asset 26.b498c7a1b94971377fc4399f2a07aba8.svg";
export { ForwardRef as ReactComponent };